// Helper para generar identificadores de ruta
// En take away usa tenantUuid, en mesa normal usa tableId

import { useAuthStore } from '../stores/useAuthStore';

// Simple slugify to create a URL-friendly string from tenant name
const slugify = (s?: string) =>
  (s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');

/**
 * Obtiene el identificador correcto para las rutas
 * - Si es take away: retorna tenant_name (slug)
 * - Si es mesa normal: retorna tableId
 */
export const getRouteId = (): string => {
  const { isTakeAway, tenantUuid, tableId, config } = useAuthStore.getState();

  // For take away, prefer a human-friendly tenant_name slug
  if (isTakeAway) {
    if (config?.tenant_name) return slugify(config.tenant_name);
    // fallback to tenantUuid only for route display (do NOT send this to API payloads)
    if (tenantUuid) return tenantUuid;
  }

  return tableId || '';
};

/**
 * Hook para obtener el identificador de ruta en componentes
 */
export const useRouteId = (): string => {
  const { isTakeAway, tenantUuid, tableId, config } = useAuthStore();

  if (isTakeAway) {
    if (config?.tenant_name) return slugify(config.tenant_name);
    if (tenantUuid) return tenantUuid;
  }

  return tableId || '';
};
